import {useMemo, useState} from 'react';

import {makeContext} from '../MakeContext';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {useSearchableJSONTreePropsContext} from './SearchableJSONTreeProvider';
import {UnflattenDelimiter} from './util/unflattenJSON';

export interface SearchableJSONTreeSettings {
  unflattenDelimiter: UnflattenDelimiter;
  setUnflattenDelimiter: (delimiter: UnflattenDelimiter) => void;
  rootKeyPath: string[]; // label for the root node, used by JSONTree
}

export const useSearchableJSONTreeSettings = (): SearchableJSONTreeSettings => {
  const {rootKeyLabel = 'Root'} = useSearchableJSONTreePropsContext();
  const rootKeyPath = useMemo(() => [rootKeyLabel], [rootKeyLabel]);

  const [unflattenDelimiter, setUnflattenDelimiter] = useState<
    UnflattenDelimiter | undefined
  >(undefined);

  return useMemo(
    () => ({unflattenDelimiter, setUnflattenDelimiter, rootKeyPath}),
    [rootKeyPath, unflattenDelimiter]
  );
};

export const {
  Provider: SearchableJSONTreeSettingsProvider,
  hook: useSearchableJSONTreeSettingsContext,
} = makeContext<SearchableJSONTreeSettings>({
  contextType: 'SearchableJSONTreeSettings',
  getContextValue: useSearchableJSONTreeSettings,
});
